import { render, staticRenderFns } from "./ManageMFA.vue?vue&type=template&id=9ff84cde"
import script from "./ManageMFA.vue?vue&type=script&lang=js"
export * from "./ManageMFA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports